export const SORT_DIRECTION = {
  ASCENDING: 1,
  DESCENDING: 2,
};

export const DEFAULT_SORT_DIRECTION = SORT_DIRECTION.ASCENDING;

export const SORT_BY = {
  TicketNumber: 1,
  Customer: 2,
  GuestType: 3,
  Rate: 4,
  EntranceTime: 5,
  Make: 6,
  Model: 7,
  Status: 8,
};
